import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled, Typography } from '@mui/material';

import { ConnectedDeviceInfo, DeviceType, ResourceType } from '../../../types';

import { getDeviceTypeByDasId } from '../../../utils/common';
import EmptyDeviceConnected from '../../EmptyDeviceConnected';

import ConnectedDeviceCardView from './ConnectedDeviceCardView';
import DasWBGTConnectedDeviceCardView from './DasWBGTConnectedDeviceCardView';

const Container = styled('div')`
  height: calc(100% - 48px);
  width: 100%;
`;

const ContainerContent = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

const ContentTitle = styled(Typography)`
  color: white;
`;

interface ConnectedDeviceViewProps {
  data: Array<ConnectedDeviceInfo>;
  resource: ResourceType;
  projectId?: string;
}

const ConnectedDeviceView: React.FC<ConnectedDeviceViewProps> = ({
  data,
  resource,
  projectId,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ContentTitle>
        {t(
          'project-settingJson.page.plant-management.dialog.create-plant.connected-device.title',
        )}
      </ContentTitle>
      <ContainerContent>
        {data.length !== 0 ? (
          data.map((device, i) => {
            if (resource === 'environment') {
              return (
                <DasWBGTConnectedDeviceCardView
                  key={i}
                  index={i}
                  dasId={device.dasId}
                  projectId={projectId}
                />
              );
            }

            let deviceType: DeviceType | undefined;
            if (resource === 'worker') {
              deviceType = getDeviceTypeByDasId(device.dasId);
            } else if (resource === 'plant') {
              deviceType = 'dastrack';
            } else if (resource === 'vehicle') {
              deviceType = 'dastrack-v';
            } else if (resource === 'pipe') {
              deviceType = 'daswater';
            } else if (resource === 'crane') {
              deviceType = 'dascas';
            } else if (resource === 'structure') {
              deviceType = 'dasconcrete';
            } else if (resource === 'ai') {
              deviceType = 'das_ai_box';
            }

            return (
              <ConnectedDeviceCardView
                key={i}
                index={i}
                data={device}
                deviceType={deviceType}
              />
            );
          })
        ) : (
          <EmptyDeviceConnected />
        )}
      </ContainerContent>
    </Container>
  );
};

export default ConnectedDeviceView;
